import { useEffect } from 'react';
import type { InvoicesThresholdData } from 'src/apis/capacity-management/types';
import type { CapacityManagementRootRequest } from 'src/apis/capacity-management/use-capacity-management-root';
import { useAxios } from 'src/hooks/use-axios';

type HookConfig = {
  capacityManagementRoot: CapacityManagementRootRequest;
};

type RequestOptions = {
  url: string;
};

export function useInvoicesThreshold({ capacityManagementRoot }: HookConfig) {
  const invoicesThreshold = useAxios(
    (axios, baseConfig, { url }: RequestOptions) =>
      axios.request<InvoicesThresholdData>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (
      !capacityManagementRoot.response ||
      !capacityManagementRoot.response.data._links?.settingsInvoicing
    )
      return;
    invoicesThreshold.execute({
      url: capacityManagementRoot.response.data._links.settingsInvoicing.href,
    });
    // oxlint-disable-next-line exhaustive-deps
  }, [capacityManagementRoot.response]);

  return invoicesThreshold;
}

export type InvoicesThresholdRequest = ReturnType<typeof useInvoicesThreshold>;
